/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  'use strict';

  /* ── Only run on product pages (not homepage/collections with featured products) ── */
  if (!document.body.classList.contains('template-product')) return;
  var initialMainBtn = document.querySelector('product-info [data-add-to-cart], [data-product-form] [data-add-to-cart]');
  if (!initialMainBtn) return;

  /* ── Read initial product info ── */
  var titleEl = document.querySelector('.product__title');
  var title = titleEl ? titleEl.textContent.trim() : '';
  if (title.length > 42) title = title.substring(0, 39) + '\u2026';

  /* ── Read initial price from the ATC button's inner span ── */
  var initialPriceEl = initialMainBtn.querySelector('[data-product-price]');
  var initialPrice = initialPriceEl ? initialPriceEl.innerHTML : '';

  /* ── Build the sticky bar ── */
  var bar = document.createElement('div');
  bar.className = 'sticky-atc-bar';
  
  bar.innerHTML =
    '<div class="sticky-atc-bar__info">' +
      '<div class="sticky-atc-bar__title">' + title + '</div>' +
      '<div class="sticky-atc-bar__variant" style="display:none;"></div>' +
    '</div>' +
    '<div class="sticky-atc-bar__actions">' +
      '<div class="sticky-atc-bar__price">' + initialPrice + '</div>' +
      '<button type="button" class="sticky-atc-bar__btn">A\u00d1ADIR AL CARRITO</button>' +
    '</div>';

  document.body.appendChild(bar);

  var stickyBtn = bar.querySelector('.sticky-atc-bar__btn');
  var priceNode = bar.querySelector('.sticky-atc-bar__price');
  var variantNode = bar.querySelector('.sticky-atc-bar__variant');

  /* ── Click → delegate to real button (re-query in case DOM was swapped) ── */
  stickyBtn.addEventListener('click', function(e) {
    e.preventDefault();
    var btn = document.querySelector('product-info [data-add-to-cart], [data-product-form] [data-add-to-cart]');
    if (btn) btn.click();
  });

  /* ── CORE: Subscribe to the theme's own pub/sub variant-change event ── */
  // This is the ONLY reliable way. The theme publishes 'variant-change' with
  // {data: {variant: {price, compare_at_price, available, ...}, html, sectionId}}
  // after it has finished updating all DOM elements.
  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
      if (!event || !event.data) return;
      var variant = event.data.variant;

      if (variant) {
        // Format the price using the theme's own formatter
        var formattedPrice;
        if (variant.price === 0) {
          formattedPrice = window.theme.strings ? window.theme.strings.free : 'Gratis';
        } else if (window.theme.formatMoney) {
          var fmt = (theme.settings && theme.settings.currency_code_enable) ? theme.moneyWithCurrencyFormat : theme.moneyFormat;
          formattedPrice = window.theme.formatMoney(variant.price, fmt);
        } else {
          formattedPrice = '\u20ac' + (variant.price / 100).toFixed(2).replace('.', ',');
        }
        priceNode.innerHTML = formattedPrice;

        // Update button state
        if (variant.available) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'A\u00d1ADIR AL CARRITO';
          stickyBtn.style.opacity = '1';
          stickyBtn.style.pointerEvents = 'auto';
        } else {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'AGOTADO';
          stickyBtn.style.opacity = '0.5';
          stickyBtn.style.pointerEvents = 'none';
        }

        // Update variant name
        var variantText = '';
        
        // Strategy 1: Use option1/option2/option3 fields (always present in Shopify variant JSON)
        var opts = [];
        if (variant.option1 && variant.option1 !== 'Default Title') opts.push(variant.option1);
        if (variant.option2 && variant.option2 !== 'Default Title') opts.push(variant.option2);
        if (variant.option3 && variant.option3 !== 'Default Title') opts.push(variant.option3);
        if (opts.length) variantText = opts.join(' / ');

        // Strategy 2: variant.title
        if (!variantText && variant.title && variant.title !== 'Default Title') {
          variantText = variant.title;
        }
        
        // Strategy 3: variant.options array
        if (!variantText && variant.options && variant.options.length) {
          variantText = variant.options.filter(function(o) { return o !== 'Default Title'; }).join(' / ');
        }
        
        // Strategy 4: variant.name minus product title
        if (!variantText && variant.name) {
          var dashIndex = variant.name.indexOf(' - ');
          variantText = dashIndex > -1 ? variant.name.substring(dashIndex + 3) : '';
        }

        // Strategy 5: Read directly from the DOM legend/labels
        if (!variantText) {
          var domOpts = [];
          document.querySelectorAll('variant-selects .radio__legend__label, variant-selects .select-popout__value').forEach(function(el) {
            var txt = el.textContent.trim();
            if (txt && txt !== 'Default Title') domOpts.push(txt);
          });
          if (domOpts.length) variantText = domOpts.join(' / ');
        }


        if (variantText) {
          variantNode.textContent = variantText;
          variantNode.style.display = 'block';
        } else {
          variantNode.style.display = 'none';
        }
      } else {
        // Variant is null = unavailable combination
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'NO DISPONIBLE';
        stickyBtn.style.opacity = '0.5';
        stickyBtn.style.pointerEvents = 'none';
      }
    });
  }

  /* ── Show / hide on scroll ── */
  var ticking = false;
  function checkScroll() {
    var btn = document.querySelector('product-info [data-add-to-cart], [data-product-form] [data-add-to-cart]');
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('is-visible', outOfView);
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', checkScroll, { passive: true });

  /* Initial check */
  checkScroll();

})();
